import { render, staticRenderFns } from "./ModalStaffPlaygroundMessenger.vue?vue&type=template&id=8d44f904&"
import script from "./ModalStaffPlaygroundMessenger.vue?vue&type=script&lang=ts&"
export * from "./ModalStaffPlaygroundMessenger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports